// extracted by mini-css-extract-plugin
export default {"scroll":"VerticalScroll_scroll__qfFFB"};